import { Box, Card, CardContent, Skeleton, Stack, Typography, useTheme } from "@mui/material";

export default function SkeletonDataGrid({ columns = [], rowsCount = 3 }) {
  const theme = useTheme();
  const HEADER_WIDTH = 130;

  const getCardStyles = (index) => {
    const isEven = index % 2 === 0;
    const backgroundColor = isEven ? theme.palette.background.paper : theme.palette.grey.A100;
    return {
      backgroundColor,
      marginTop: "0px !important",
    };
  };

  const renderSkeletonCard = (index = 0) => (
    <Card className="responsive-data-grid-card skeleton-card" elevation={0} sx={getCardStyles(index)}>
      <CardContent className="responsive-data-grid-card-content">
        <Stack spacing={1}>
          {columns.map((col, colIndex) => {
            if (!col) return null;

            const fieldKey = col.field || `skeleton-${colIndex}`;
            const headerName = col.headerName || col.field || "Field";

            return (
              <Stack key={fieldKey} direction="row" justifyContent="flex-start" alignItems="center">
                <Typography variant="subtitle2" width={HEADER_WIDTH} marginBottom={2}>
                  {headerName}
                </Typography>
                <Box component="span">
                  <Skeleton variant="text" width={col.skeletonWidth || 120} height={20} />
                </Box>
              </Stack>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );

  return (
    <Stack spacing={2}>
      {[...Array(rowsCount)].map((_, i) => (
        <Box key={i}>{renderSkeletonCard(i)}</Box>
      ))}
    </Stack>
  );
}
